var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecureCheckoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 69,
    viewBox: "0 0 74 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68429 14.8139H2.56523C1.39492 14.8139 0.446167 15.7614 0.446167 16.9301V32.2731C0.446167 33.4418 1.39492 34.3894 2.56523 34.3894H27.4642C28.6345 34.3894 29.5833 33.4418 29.5833 32.2731V16.9301C29.5833 15.7614 28.6345 14.8139 27.4642 14.8139H25.3452V10.3168C25.3452 4.61899 20.7201 0 15.0147 0C9.30939 0 4.68429 4.61899 4.68429 10.3168V14.8139ZM6.80336 14.8139H23.2261V10.3168C23.2261 5.78777 19.5497 2.11627 15.0147 2.11627C10.4797 2.11627 6.80336 5.78777 6.80336 10.3168V14.8139ZM16.0304 23.5058C16.5354 23.175 16.8689 22.6045 16.8689 21.9563C16.8689 20.9336 16.0388 20.1045 15.0147 20.1045C13.9907 20.1045 13.1605 20.9336 13.1605 21.9563C13.1605 22.6045 13.494 23.175 13.999 23.5058C13.9705 23.6015 13.9552 23.703 13.9552 23.808V25.9243C13.9552 26.5087 14.4295 26.9824 15.0147 26.9824C15.5999 26.9824 16.0743 26.5087 16.0743 25.9243V23.808C16.0743 23.703 16.0589 23.6015 16.0304 23.5058Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5768 36.5057V55.023C20.5768 57.945 22.9486 60.3137 25.8744 60.3137H51.9251L63.9415 68.6777C64.644 69.1666 65.6069 68.6647 65.6069 67.8096V60.3137H68.2557C71.1815 60.3137 73.5534 57.945 73.5534 55.023V31.215C73.5534 28.293 71.1815 25.9243 68.2557 25.9243H31.7019V32.2731C31.7019 34.6107 29.8044 36.5057 27.4637 36.5057H20.5768ZM33.2912 35.4475C33.2912 34.8631 33.7655 34.3894 34.3507 34.3894H59.7795C60.3646 34.3894 60.839 34.8631 60.839 35.4475C60.839 36.0319 60.3646 36.5057 59.7795 36.5057H34.3507C33.7655 36.5057 33.2912 36.0319 33.2912 35.4475ZM33.2912 42.8545C33.2912 42.27 33.7655 41.7963 34.3507 41.7963H59.7795C60.3646 41.7963 60.839 42.27 60.839 42.8545C60.839 43.4389 60.3646 43.9126 59.7795 43.9126H34.3507C33.7655 43.9126 33.2912 43.4389 33.2912 42.8545ZM34.3507 49.2033C33.7655 49.2033 33.2912 49.677 33.2912 50.2614C33.2912 50.8457 33.7655 51.3195 34.3507 51.3195H59.7795C60.3646 51.3195 60.839 50.8457 60.839 50.2614C60.839 49.677 60.3646 49.2033 59.7795 49.2033H34.3507Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.0147,
    y1: 0,
    x2: 15.0147,
    y2: 34.3894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 47.0651,
    y1: 25.9243,
    x2: 47.0651,
    y2: 68.8696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22123"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureCheckoutIcon);
export default __webpack_public_path__ + "static/media/secure_checkout_icon.1bfde667b0a63be4e884514dccb25f84.svg";
export { ForwardRef as ReactComponent };